import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import NotificationRulesService from '@services/notification-rules';
import { fetchNotificationRules, updateNotificationRules } from '@actions/notification-rules';
import { NotificationRule } from '@rootCommon/types/site';
import { IdType } from '@rootCommon/types/common';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchNotificationRulesAsync(action: { payload: IdType }) {
  try {
    const notificationRules: NotificationRule[] = yield call(NotificationRulesService.getBySiteId, action.payload);

    yield put(fetchNotificationRules.success(notificationRules));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(fetchNotificationRules.failure(error));
  }
}

function* watchFetchNotificationRules() {
  yield takeLatest(fetchNotificationRules.request, fetchNotificationRulesAsync);
}

// update
function* updateONotificationRulesAsync(action: { payload: { siteId: IdType; data: NotificationRule[] } }) {
  try {
    yield call(NotificationRulesService.updateBySiteId, action.payload.siteId, action.payload.data);
    yield put(updateNotificationRules.success(action.payload.data));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(updateNotificationRules.failure(error));
  }
}

function* watchUpdateNotificationRules() {
  yield takeLatest(updateNotificationRules.request, updateONotificationRulesAsync);
}

// all
function* watchNotificationRules(): SagaGenerator {
  yield all([watchFetchNotificationRules(), watchUpdateNotificationRules()]);
}

export default watchNotificationRules;
